import React, { useEffect, useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { InnerSelect } from '@alphapoint/apex-web/lib/components/common/APSelect';
import SwitchIcon from './switch-icon.svg';

const BuySellInstrumentSelector = ({
  buyLabel,
  sellLabel,
  product2Options,
  isBuySide,
  baseClasses,
  instruments,
  selectedInstrument,
  onInstrumentSelect,
  setBuySide,
  setSellSide,
  clearForm,
}) => {
  const { t } = useTranslation('core');
  const [selectedProduct2, setSelectedProduct2] = useState(null);

  const filteredInstrumentsByProduct2 = useMemo(
    () =>
      selectedProduct2 ? instruments.filter((instrument) => instrument.Product2 === selectedProduct2) : instruments,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [instruments.length, selectedProduct2],
  );

  useEffect(() => {
    const preSelectedInstrument = instruments.find((i) => i.InstrumentId === selectedInstrument.InstrumentId);

    if (preSelectedInstrument || !instruments.length) {
      setSelectedProduct2(preSelectedInstrument.Product2);
      return;
    }

    const instrumentId = instruments[0].InstrumentId;
    setSelectedProduct2(instruments[0].Product2);
    onInstrumentSelect(instrumentId);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onProduct2Select = (value) => {
    const newProduct2 = Number(value);
    setSelectedProduct2(newProduct2);
    const filteredInstruments = instruments.filter((instrument) => instrument.Product2 === newProduct2);
    onInstrumentSelect(filteredInstruments[0].InstrumentId);
  };

  const onSwitchClick = () => {
    clearForm();
    if (isBuySide) {
      setSellSide();
    } else {
      setBuySide();
    }
  };

  return (
    <div className={baseClasses('crypto-container')}>
      <div className={baseClasses('crypto-container-selects-labels')}>
        <p className={baseClasses('crypto-container-selects-label')}>{t(buyLabel)}</p>
        <div className={baseClasses('crypto-container-selects-divider')} />
        <p className={baseClasses('crypto-container-selects-label', 'sell')}>{t(sellLabel)}</p>
      </div>
      <div className={baseClasses('crypto-container-selects', isBuySide ? 'buy-side' : 'sell-side')}>
        <InnerSelect
          showTriangles
          name="instrument"
          customClass={baseClasses()}
          onSelect={onInstrumentSelect}
          value={selectedInstrument.InstrumentId}
          options={filteredInstrumentsByProduct2.map((instrument) => ({
            value: instrument.InstrumentId,
            label: instrument.Product1FullName,
          }))}
        />
        <div className={baseClasses('switch-icon')} onClick={onSwitchClick}>
          <img src={SwitchIcon} alt="Switch" />
        </div>
        <InnerSelect
          showTriangles
          name="product2"
          customClass={baseClasses()}
          onSelect={onProduct2Select}
          value={selectedProduct2}
          options={product2Options}
        />
      </div>
    </div>
  );
};

BuySellInstrumentSelector.propTypes = {
  baseClasses: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  onInstrumentSelect: PropTypes.func.isRequired,
  instruments: PropTypes.array.isRequired,
  selectedInstrument: PropTypes.object.isRequired,
};

export default BuySellInstrumentSelector;
